import React, { Component, useEffect, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import Dropzone from 'react-dropzone';
import Alert from '@material-ui/lab/Alert';
import { isEmpty } from 'lodash';
import {Box,IconButton} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import IntlMessages from 'util/IntlMessages';
const baseStyle = {
    fontSize: '1rem',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    borderWidth: 2,
    borderRadius: 5,
    borderColor: 'grey',
    borderStyle: 'dashed',
    backgroundColor: 'white',
    color: 'grey',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '70px',
};
const activeStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};
function StyledDropzone(props) {
    let messageLaddaFile=<IntlMessages id="Body.file.max2MB" />;
    const style = useMemo(() => ({
        ...baseStyle
    }), [
        
    ]);
    const onDrop = (acceptedFiles) => {  
        let files = []
        let rrejectedFiles = []
        for(let ffile of acceptedFiles){
            console.log(ffile.size)
            if(ffile.size < 2048570){
                files.push(ffile)   
            }else{
                rrejectedFiles.push(ffile)  
            }
        }
        console.log(rrejectedFiles,"rrejectedFiles")
        props.getFile(files)
        props.getrrejectedFiles(rrejectedFiles)
    }
    //10MB
    const maxSize = 2048570;
    
    return (
        
        <>
        <Dropzone onDrop={onDrop}
        accept="
        application/pdf,.pdf,*.pdf,
        .xls,.xlsx,.xlsm,
        .doc, .docx,.ppt, .pptx,
        .png,.jpg,.jpeg,.msg
        "
        minSize={0}
        >
          {({getRootProps, getInputProps, isDragActive,isDragAccept ,isDragReject,rejectedFiles,acceptedFiles}) => {
            const isFileTooLarge = rejectedFiles.length > 0;
              return (<div {...getRootProps({style})}>
              <input {...getInputProps()} />         
              {!isDragReject && !isDragAccept && !isDragActive && messageLaddaFile}    
            </div>
            )
            }
        }
        </Dropzone>
      </>
    )
}

export default class ImportExcelFile extends Component {
    state={
        acceptedFiles:[],
        fileRejectionItems:[]
    }
    getFile=(files)=>{
        let AcceptedFiles = this.state.acceptedFiles
        for(let item of files){
            if(isEmpty(AcceptedFiles.filter(itemm=>itemm.path === item.path))){
                AcceptedFiles.push(item)
            }
        }
        const result = AcceptedFiles.filter((thing, index, self) =>
        index === self.findIndex((t) => (
            JSON.stringify(t) === JSON.stringify(thing)
              ))
        )
        this.setState({
            acceptedFiles:result
        })
        this.props.onchangeHanelEvent("Files",result)
    }
    getrrejectedFiles=(files)=>{
        console.log(files)
        let fileRejectionItems = this.state.fileRejectionItems
        for(let item of files){
            if(isEmpty(fileRejectionItems.filter(itemm=>itemm.path === item.path))){
                fileRejectionItems.push(item)
            }
        }
        const result = fileRejectionItems.filter((thing, index, self) =>
        index === self.findIndex((t) => (
            JSON.stringify(t) === JSON.stringify(thing)
              ))
        )
        this.setState({
            fileRejectionItems:result
        })
    }
    onRemoveFilefromList = (file)=>{
        let acceptedFiles = this.state.acceptedFiles.filter(item =>{
            return JSON.stringify(item) !== JSON.stringify(file)
        })
        this.setState({
            acceptedFiles:acceptedFiles
        })
        this.props.onchangeHanelEvent("Files",acceptedFiles)
    }
    render() {
        return (
            <section className="container">
                <StyledDropzone getFile={this.getFile} getrrejectedFiles={this.getrrejectedFiles} file={this.props.Value}/>
                <aside>
                    {
                        !isEmpty(this.state.acceptedFiles)?
                        <>
                         <h4>Accepted files</h4>
                    <ul>{
                    this.state.acceptedFiles.map(file => (
                        <li key={file.path}>
                            <Box display="flex" p={0}>
                            <Box p={0} flexGrow={1}>
                            <span style={{maxWidth: "150px",whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis"}} >
                            {file.path}    
                            </span> - {file.size}B
                            </Box>
                            <Box p={0}>
                            <IconButton aria-label="delete" color="secondary" size="small"
                            onClick={(e)=>this.onRemoveFilefromList(file)}>
                                <CloseIcon/>
                            </IconButton>
                            </Box>
                            </Box>
                        </li>
                    ))
                    }
                    </ul>
                        </>
                        :""
                    }
                    {
                        !isEmpty(this.state.fileRejectionItems)?
                        <>
                         <h4>Rejected files</h4>
                    <ul>{
                    this.state.fileRejectionItems.map(file => (
                        <li key={file.path} style={{color:"#f44336"}}>
                            {file.path} - {file.size} bytes
                        </li>
                    ))
                    }
                    </ul>
                        </>
                        :""
                    }
                 
                </aside>
            </section>
        )
    }
}